import type React from 'react'
import {useState} from 'react'

import {emptyArray} from '../../../../../../../../../utils/empty'
import {getOriginalPipelineTriggers} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {usePipelineId} from '../../../../../../hooks/pipeline'

import {TriggerSchedulingPolicy, TriggerType} from './PipelineTriggers.consts'
import type {TriggerParameters} from './PipelineTriggers.types'

import {
  collapsedBlocks,
  pipelineDraft,
} from 'src/components/pages/PipelinesPages/EditPipelinePage/slices/EditPipelinePage.slices'
import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

function usePipelineTriggers() {
  const dispatch = useAppDispatch()
  const id = usePipelineId()
  const sevedTriggers = useAppSelector(getOriginalPipelineTriggers(id)) ?? emptyArray
  const [isShowTriggerForm, setIsShowTriggerForm] = useState<boolean>(false)
  const triggers = useAppSelector(state => state.pipelines.pipelineDraft[id]?.draft?.triggers)
  const handlerAddJobTriggerButtonClick = () => {
    dispatch(collapsedBlocks.actions.toggle({id: 'triggers', collapsed: false}))
    setIsShowTriggerForm(true)
  }
  const handlerJobTriggerFormApply = (parameters: TriggerParameters) => {
    dispatch(
      pipelineDraft.actions.addTrigger({
        id,
        type: TriggerType.SCHEDULE,
        parameters: {
          ...parameters,
          schedulingPolicy: TriggerSchedulingPolicy.WEEKLY,
        },
        disabled: false,
      }),
    )

    setIsShowTriggerForm(false)
  }
  const handlerJobTriggerFormClose = () => setIsShowTriggerForm(false)
  const handlerDisabledToggleChange =
    (index: number) =>
    ({currentTarget}: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(
        pipelineDraft.actions.toggleDisabledTrigger({
          id,
          index,
          value: !currentTarget.checked,
        }),
      )
    }
  const handlerJobTriggerEditApply = (index: number) => (parameters: TriggerParameters) =>
    dispatch(
      pipelineDraft.actions.changeTrigger({
        id,
        index,
        parameters,
      }),
    )
  const handlerTriggerDelete = (index: number) => () =>
    dispatch(pipelineDraft.actions.deleteTrigger({id, index}))

  return {
    triggers,
    sevedTriggers,
    isShowTriggerForm,
    handlerDisabledToggleChange,
    handlerAddJobTriggerButtonClick,
    handlerJobTriggerFormApply,
    handlerJobTriggerFormClose,
    handlerJobTriggerEditApply,
    handlerTriggerDelete,
  }
}

export default usePipelineTriggers
